"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voiceSchema = void 0;
const zod_1 = require("zod");
exports.voiceSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    profile: zod_1.z.object({
        name: zod_1.z.string(),
        photoURL: zod_1.z.string(),
        country: zod_1.z.string(),
        countryCode: zod_1.z.string(),
        shortDescription: zod_1.z.string(),
        summaryTopics: zod_1.z.array(zod_1.z.string()),
        longDescription: zod_1.z.string(),
        from: zod_1.z.string(),
        profession: zod_1.z.string(),
        subjects: zod_1.z.string(),
    }),
});
//# sourceMappingURL=voice.js.map